/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export type SolutionInfo = {
  id: string;
  name: string;
  url?: string;
  signUp?: number;
};

export const SOLUTIONS: Record<string, SolutionInfo> = {
  landraeume: {
    id: 'landraeume',
    name: 'LandRäume',
    url: import.meta.env.VITE_LANDRAUEME_URL as string
  },
  'gesundheit-und-pflege': {
    id: 'gesundheit-und-pflege',
    name: 'LandWohl'
  },
  kuubu: {
    id: 'kuubu',
    name: 'kuubu'
  },
  'mein-digitaler-landkreis': {
    id: 'mein-digitaler-landkreis',
    name: 'Marktplatz DEUTSCHLAND.DIGITAL',
    url: import.meta.env.VITE_MARKETPLACE_URL as string
  },
  'neighbourhood-diagnostics': {
    id: 'neighbourhood-diagnostics',
    name: 'Neighborhood Diagnostics',
    url: 'https://www.zdd.fraunhofer.de/de/zdd-projekte/neigborhood-diagnostics.html'
  },
  ridesharebenches: {
    id: 'ridesharebenches',
    name: 'Comby',
    url: import.meta.env.VITE_COMBY_URL as string
  },
  planbar: {
    id: 'planbar',
    name: 'PlanBar',
    url: import.meta.env.VITE_PLANBAR_URL as string
  }
};
